import { rootStateBranchSelector } from '../rootStateBranchSelector';

export const getFilters = rootStateBranchSelector('filter');
